import colors from '@/store/colors';

const tag = (text, color) => ({ text, color });

export default {
  // Языки программирования
  js: tag('JS', colors.red),
  ts: tag('TS', colors.red),
  kotlin: tag('Kotlin', colors.red),
  java: tag('Java', colors.red),
  c: tag('C', colors.red),
  cpp: tag('C++', colors.red),
  rust: tag('Rust', colors.red),
  python: tag('Python', colors.red),
  bash: tag('Bash', colors.red),

  // Фреймворки, библиотеки
  django: tag('Django', colors.blue),
  vue: tag('Vue', colors.blue),
  vueLife: tag('Vue (для души)', colors.blue),
  react: tag('React', colors.blue),
  reactWork: tag('React (по работе)', colors.blue),
  reactNative: tag('React Native', colors.blue),
  svelte: tag('Svelte', colors.blue),
  flutter: tag('Flutter', colors.blue),
  scss: tag('SCSS', colors.blue),

  // Утилиты, операционные системы
  nginx: tag('nginx', colors.green),
  webpack: tag('webpack', colors.green),
  puppet: tag('puppet', colors.green),
  android: tag('Android', colors.green),

  // Дизайн
  photoshop: tag('Adobe Photoshop', colors.purple),
  figma: tag('Figma', colors.purple),
  sketch: tag('Sketch', colors.purple),
};
